import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RolesService } from '../services/roles/roles.service';
import { UsuarioService } from '../services/service.index';

@Injectable()
export class LoginUnitaGuard implements CanActivate {
  constructor(
    private router: Router,
    private rolesService: RolesService,
    private usuarioService: UsuarioService
  ) {}

  canActivate(): boolean {
    if (localStorage.getItem('quiensoy') === 'unita' && localStorage.getItem('tkn')) {
      const rid = localStorage.getItem('rid');
      if (rid) {
        this.rolesService.getRol(rid).subscribe(resp => {
          if (resp[0].name === 'SuperAdmin' || resp[0].name === 'Analista') {
            this.router.navigate(['/panelcontrol/aprobarCreditos']);
          } else if (resp[0].name === 'Vendedor') {
            this.router.navigate(['/panelcontrol/revisarCotizaciones']);
          } else if (resp[0].name === 'Médico') {
            this.usuarioService.getCustomerxidu(localStorage.getItem('uid')).subscribe(r => {
              if (r.length > 0) {
                this.router.navigate([`/maincliente/solicitudcredito/${localStorage.getItem('uid')}`]);
              } else {
                this.router.navigate([`/registroemp`]);
              }
            });
          } else {
            this.router.navigate(['/panelcontrol/aprobarCreditos/mesaControl']);
          }
        });
      }
      return false;
    }
    return true;
  }
}
